import { render, staticRenderFns } from "./IconTip.vue?vue&type=template&id=57f6c891&scoped=true"
import script from "./IconTip.vue?vue&type=script&lang=js"
export * from "./IconTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6c891",
  null
  
)

export default component.exports